<template>
    <vx-sticky-nav v-if="!props.hideNav" :sections="props.sections" class="w-full" :contentClasses="columnClasses">
        <slot></slot>
    </vx-sticky-nav>
    <!-- An edit page sits beside a sidebar and has no section nav, so its cards go in a plain column at the start. -->
    <div v-else :class="columnClasses">
        <slot></slot>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { VxStickyNav } from '@voxie/frontend-components';

const props = defineProps({
    hideNav: Boolean,
    sections: Array,
    // The automation form's builders need the wide column; its small cards center inside it on the create page.
    wide: Boolean,
});

const columnClasses = computed(() =>
    props.wide
        ? `flex w-full flex-col gap-4 md:max-w-(--breakpoint-lg) md:gap-6 xl:gap-8 ${props.hideNav ? 'items-start' : 'items-center'}`
        : 'flex w-full flex-col gap-4 md:max-w-2xl md:gap-6 xl:gap-8'
);
</script>
